import type { ILogger, ILoggerProvider } from './types';

export function createLogger(provider: ILoggerProvider): ILogger {
  return {
    debug(message, fields) {
      provider.log('debug', message, fields);
    },
    info(message, fields) {
      provider.log('info', message, fields);
    },
    warn(message, fields) {
      provider.log('warn', message, fields);
    },
    error(message, fields) {
      provider.log('error', message, fields);
    },
  };
}
